import { fetcher } from "helpers/fetcher";

import { TUpdateStaffInsuranceReq, TUpdateStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateStaffInsurance = async (
  payload: TUpdateStaffInsuranceReq
) => {
  return await fetcher<
    TUpdateStaffInsuranceRes,
    TUpdateStaffInsuranceReq["data"]
  >(ENDPOINT.USER.UPDATE_STAFF_INSURANCE, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_STAFF_INSURANCE.version,
    },
  });
};

export const mutationUpdateStaffInsurance = async (
  payload: TUpdateStaffInsuranceReq
) => {
  return (await updateStaffInsurance(payload)).data.message;
};

mutationUpdateStaffInsurance._key = (payload: TUpdateStaffInsuranceReq) => [
  ENDPOINT.USER.UPDATE_STAFF_INSURANCE.url,
  payload,
];
